/**
 * THY AppFeedback teşhis izi (096 / FR-015).
 *
 * Bileşen hataları tamamen yutuyor: sorgulama isteği 200 dışında bir şey dönerse anket sadece
 * **hiç görünmüyor** ve hiçbir yerde hata üretmiyor. Bu, "THY sorma dedi" durumundan ayırt
 * edilemez. Üstelik entegrasyon yalnız THY ortamında koşuyor, oraya doğrudan erişimimiz yok —
 * teslimden sonra sessizce bozulabilir ve tek belirti THY'nin "veri gelmiyor" demesi olur.
 *
 * Bu yüzden kullanıcıya **görünmeyen** bir teşhis izi bırakılır. Kasıtlı sınırlar:
 *
 * - Yalnız tarayıcı konsoluna yazılır; **arka uca bildirim yapılmaz** (böyle bir kanal yok ve
 *   ikincil bir özellik için sıfırdan kurmak orantısız olurdu).
 * - Yalnız entegrasyonun etkin olduğu ya da etkin olması BEKLENEN ortamlarda yazılır. THY dışı
 *   ortamda tam sessizlik esastır (US2: "konsol gürültüsü" de hissedilen bir etkidir).
 */

import { isAppFeedbackEnabled, isThyOrigin } from './config'

const PREFIX = '[AppFeedback]'

/** Eksik yapılandırma uyarısı oturumda bir kez yazılır; her tetiklemede tekrarlaması gürültü olur. */
let missingConfigReported = false

/**
 * Teşhis izinin bu ortamda yazılıp yazılmayacağı.
 *
 * `isThyOrigin()` burada **ikinci bir koşul olarak** var: entegrasyon kapalı ama THY alan adı
 * altındaysak, bu "bilinçli kapatma" değil "yapılandırma eksik" demektir ve tam da fark edilmesi
 * gereken durumdur.
 */
function shouldReport(): boolean {
  return isAppFeedbackEnabled() || isThyOrigin()
}

/** Beklenmedik bir aksaklığı kaydeder. Kullanıcıya hiçbir şey gösterilmez (FR-007). */
export function reportAppFeedbackIssue(message: string, detail?: unknown): void {
  if (!shouldReport()) return
  if (detail === undefined) {
    console.warn(`${PREFIX} ${message}`)
  } else {
    console.warn(`${PREFIX} ${message}`, detail)
  }
}

/**
 * "THY ortamındayız ama derleme parametresi tanımlanmamış" durumunu bildirir.
 *
 * Bu, teslimin en olası sessiz arıza biçimidir: `VITE_APPFEEDBACK_BASE_URL` THY'nin kendi derleme
 * yapılandırmasında tanımlanmazsa entegrasyon hiç devreye girmez ve hiçbir belirti vermez.
 * Buradaki iz, o durumu "bilinçli kapatma"dan ayıran tek sinyaldir.
 */
export function reportMissingConfiguration(): void {
  if (missingConfigReported) return
  if (!isThyOrigin() || isAppFeedbackEnabled()) return
  missingConfigReported = true
  console.warn(
    `${PREFIX} Ortam parametresi (VITE_APPFEEDBACK_BASE_URL) tanımsız, ancak uygulama bir THY ` +
      `alan adı altında çalışıyor. Entegrasyon devre dışı — bu bilinçli bir kapatma değil, ` +
      `derleme yapılandırmasının eksik olduğu anlamına gelir.`,
  )
}
